/** Staff CRM: quotes, clients, properties, staff messaging. */
export default {
  /** "Label : " (French spacing before the colon). */
  labelColon: '{{label}} :',
  filters: { allSectors: 'Tous les secteurs' },
  form: {
    invalid: 'Valeur invalide.',
    checkFields: 'Certaines informations sont manquantes ou invalides. Vérifiez le formulaire.',
  },
  picker: {
    searchClient: 'Rechercher un client (nom, courriel, téléphone, adresse)…',
    results: 'Clients trouvés',
    noClient: 'Aucun client trouvé.',
    change: 'Changer',
  },
  errors: {
    TOTAL_MUST_BE_POSITIVE: 'Le total doit être supérieur à 0 $.',
    NO_PRICE: 'Enregistrez d’abord une version de prix.',
    QUOTE_WITHOUT_DATE: 'La soumission n’a pas de date demandée : impossible de créer le ménage.',
    QUOTE_NOT_FOUND: 'Soumission introuvable.',
    CLIENT_REQUIRED: 'Choisissez un client.',
    CUSTOM_INTERVAL_REQUIRED: 'Indiquez l’intervalle en jours.',
    NOT_YOUR_PROPERTY: 'Cette propriété n’appartient pas à ce client.',
    SERVICE_TYPE_NOT_FOUND: 'Type de service introuvable.',
    AGREEMENT_NOT_FOUND: 'Service récurrent introuvable.',
    AGREEMENT_NOT_ACTIVE: 'Ce service n’est pas actif.',
    AGREEMENT_NOT_PAUSED: 'Ce service n’est pas en pause.',
    AGREEMENT_CLOSED: 'Ce service est déjà terminé ou annulé.',
    USE_CANCEL_INSTEAD: 'Pour arrêter les visites, annulez plutôt le service.',
    STAFF_ONLY_ACTION: 'Action réservée à l’équipe.',
    ONE_COUNTERPART_ONLY: 'Choisissez un seul destinataire.',
    JOB_NOT_FOUND: 'Ménage introuvable.',
  },

  // ---------------------------------------------------------------- quotes list
  quotes: {
    title: 'Soumissions',
    description: 'Demandes de prix des clients : analyse, prix officiel, envoi et réponse.',
    search: 'Client, ville ou n° de soumission',
    tabs: { todo: 'À traiter', sent: 'Envoyées', accepted: 'Acceptées', closed: 'Refusées / expirées', all: 'Toutes' },
    empty: {
      todo: 'Aucune soumission à traiter. Tout est à jour.',
      sent: 'Aucune soumission en attente de réponse du client.',
      accepted: 'Aucune soumission acceptée pour le moment.',
      closed: 'Aucune soumission refusée ou expirée.',
      all: 'Aucune soumission pour le moment.',
    },
    emptySearch: 'Aucune soumission ne correspond à cette recherche.',
    estimateShort: 'est. {{amount}}',
    estimateInternal: 'Estimation interne (aucun prix officiel encore)',
    fields: {
      property: 'Propriété',
      service: 'Service',
      frequency: 'Fréquence du service',
      frequencyHint: 'Rythme des visites. La facturation se choisit à part, lors de la proposition de prix.',
      customIntervalDays: 'Intervalle (jours)',
      contractTerm: 'Contrat',
      contractOnlyRecurring: 'Un contrat ne s’applique qu’à un service récurrent.',
      requested: 'Date souhaitée',
      requestedDate: 'Date souhaitée',
      requestedTime: 'Heure souhaitée',
      extras: 'Extras',
      specialRequests: 'Demandes particulières',
      received: 'Reçue le',
    },
    new: {
      button: 'Nouvelle soumission',
      title: 'Nouvelle soumission',
      description: 'Pour une demande reçue par téléphone ou en personne. L’estimation interne est calculée automatiquement.',
      noProperty: 'Ce client n’a aucune propriété active.',
      addProperty: 'Ajouter une propriété',
      submit: 'Créer la soumission',
      created: 'Soumission créée.',
    },
  },

  // ---------------------------------------------------------------- quote detail
  quote: {
    title: 'Soumission #{{number}}',
    subtitle: 'Reçue le {{date}}',
    request: 'Demande du client',
    snapshot: 'Propriété au moment de la demande',
    snapshotHint: 'Ces caractéristiques ont servi au calcul de l’estimation. Les modifications de la propriété ne les changent pas.',
    snap: {
      bedrooms_one: '{{count}} chambre',
      bedrooms_other: '{{count}} chambres',
      bathrooms_one: '{{count}} salle de bain',
      bathrooms_other: '{{count}} salles de bain',
      kitchens_one: '{{count}} cuisine',
      kitchens_other: '{{count}} cuisines',
      familyRooms_one: '{{count}} espace familial',
      familyRooms_other: '{{count}} espaces familiaux',
      floors_one: '{{count}} étage',
      floors_other: '{{count}} étages',
      sqft_one: '{{count}} pi²',
      sqft_other: '{{count}} pi²',
      pets: 'Animaux',
    },
    everyDays_one: 'Chaque jour',
    everyDays_other: 'Tous les {{count}} jours',
    timeline: {
      submitted: 'Demande reçue : {{date}}',
      sent: 'Envoyée au client : {{date}}',
      responded: 'Réponse du client : {{date}}',
      duration_one: 'Durée prévue : {{duration}} · {{count}} personne',
      duration_other: 'Durée prévue : {{duration}} · {{count}} personnes',
    },
    clientNote: 'Note du client',
    takeOver: 'Prendre en charge',
    reviewTaken: 'Vous traitez cette soumission.',
    reopen: 'Rouvrir l’analyse',
    reopened: 'Soumission rouverte.',
    send: 'Envoyer au client',
    sendVersion: 'Envoyer V{{version}} au client',
    sentToast: 'Soumission envoyée au client.',
    acceptForClient: 'Accepter pour le client',
    rejectForClient: 'Refuser pour le client',
    confirmAccept: {
      title: 'Accepter au nom du client ?',
      description: 'La version V{{version}} ({{amount}}) sera acceptée. Le ménage (ou le service récurrent) sera créé et le client recevra une confirmation.',
    },
    confirmReject: {
      title: 'Refuser au nom du client ?',
      description: 'La soumission sera marquée comme refusée. Vous pourrez la rouvrir plus tard.',
    },
    responseNote: 'Note (facultatif)',
    responseNoteHint: 'Ex. : « Acceptée par téléphone le 2 octobre ».',
    acceptedToast: 'Soumission acceptée.',
    acceptedWithJob: 'Soumission acceptée. Le premier ménage est créé et attend une assignation.',
    rejectedToast: 'Soumission refusée.',
    cancel: 'Annuler la soumission',
    confirmCancel: {
      title: 'Annuler la soumission #{{number}} ?',
      description: 'La soumission ne pourra plus être modifiée ni acceptée. L’historique des versions est conservé.',
    },
    cancelledToast: 'Soumission annulée.',
    messageClient: 'Écrire au client',
    conversationSubject: 'Soumission #{{number}}',
    notEditable: 'Le prix de cette soumission ne peut plus être modifié.',
    acceptedBanner: 'Acceptée : V{{version}} à {{amount}}.',
    seeAgreement: 'Voir le service récurrent',
    seeJobs: 'Voir les ménages du client',
  },
  estimate: {
    title: 'Estimation interne',
    description: 'Calcul automatique à partir des caractéristiques. Jamais montré au client : seul le prix officiel lui est envoyé.',
    none: 'Aucune estimation disponible pour cette demande.',
    total: 'Total estimé',
    duration_one: '{{duration}} · {{count}} personne recommandée',
    duration_other: '{{duration}} · {{count}} personnes recommandées',
  },
  pricing: {
    title: 'Prix officiel',
    description: 'Chaque enregistrement crée une nouvelle version (V{{version}}). Les versions précédentes restent dans l’historique.',
    fromEstimate: 'Repartir de l’estimation',
    fromVersion: 'Repartir de V{{version}}',
    roundingLine: 'Arrondi / minimum',
    line: {
      label: 'Description',
      labelPlaceholder: 'Ex. : Ménage standard, Intérieur du four…',
      quantity: 'Qté',
      unit: 'Prix unitaire ($)',
      total: 'Total',
      add: 'Ajouter une ligne',
      remove: 'Retirer la ligne',
      discountHint: 'Pour un rabais, indiquez un prix unitaire négatif (ex. : -15).',
    },
    totalNew: 'Total V{{version}}',
    compare: 'V{{from}} {{fromAmount}} → V{{to}} {{toAmount}}',
    estimatedMinutes: 'Durée prévue (minutes)',
    requiredWorkers: 'Personnes requises',
    billing: 'Facturation',
    billingHint: 'Indépendante de la fréquence du service ({{frequency}}).',
    messageToClient: 'Message au client',
    messageHint: 'Visible par le client avec le prix.',
    internalNote: 'Note interne',
    internalNoteHint: 'Visible seulement par l’équipe.',
    validUntil: 'Valide jusqu’au',
    validUntilHint: 'Après cette date, la soumission expire.',
    invalid: 'Vérifiez les lignes : description, quantité (entier ≥ 1) et prix unitaire sont obligatoires. La durée est d’au moins 15 minutes.',
    replacesSent: 'Cette soumission a déjà été envoyée : une nouvelle version la remet en proposition jusqu’au prochain envoi.',
    saveVersion: 'Enregistrer la version V{{version}}',
    saveAndSend: 'Enregistrer et envoyer au client',
    needsApproval: 'L’envoi au client demande la permission d’approbation des prix.',
    savedToast: 'Version V{{version}} enregistrée.',
    sentToast: 'Version V{{version}} ({{amount}}) envoyée au client.',
    confirmSend: {
      title: 'Envoyer la version V{{version}} au client ?',
      description: '{{name}} recevra le prix de {{amount}} et pourra l’accepter ou le refuser.',
    },
  },
  versions: {
    title: 'Historique des versions',
    none: 'Aucun prix proposé pour le moment.',
    by: 'Par {{author}} · {{date}}',
    current: 'Version actuelle',
    sent: 'Envoyée',
    accepted: 'Acceptée',
    workers_one: '{{count}} personne',
    workers_other: '{{count}} personnes',
    discount: 'rabais {{amount}}',
    showLines_one: 'Voir la ligne',
    showLines_other: 'Voir les {{count}} lignes',
  },

  // ---------------------------------------------------------------- clients
  clients: {
    title: 'Clients',
    count_one: '{{count}} client',
    count_other: '{{count}} clients',
    search: 'Nom, courriel, téléphone ou adresse',
    showArchived: 'Clients archivés',
    empty: 'Aucun client pour le moment.',
    emptyArchived: 'Aucun client archivé.',
    emptySearch: 'Aucun client ne correspond à cette recherche.',
    recurring: 'Récurrent',
    occasional: 'Ponctuel',
    archived: 'Archivé',
    contact: 'Contact',
    properties_one: '{{count}} propriété',
    properties_other: '{{count}} propriétés',
    propertiesShort: 'Propriétés',
    type: 'Type',
    nextJob: 'Prochain ménage',
    noNextJob: 'Aucun prévu',
  },
  client: {
    new: 'Nouveau client',
    newHint: 'Le client pourra créer son compte plus tard avec le même courriel.',
    create: 'Créer le client',
    created: 'Client créé.',
    edit: 'Modifier le client',
    saved: 'Client mis à jour.',
    since: 'Client depuis le {{date}}',
    profile: 'Profil',
    account: 'Compte en ligne',
    noAccount: 'Aucun compte (géré par l’équipe)',
    accountNeverUsed: 'Compte créé, jamais utilisé',
    lastLogin: 'Dernière connexion : {{date}}',
    fields: {
      displayName: 'Nom',
      secondaryPhone: 'Autre téléphone',
      source: 'Provenance',
      sourceHint: 'Ex. : référence, Facebook, site web.',
      internalNotes: 'Notes internes',
      internalNotesHint: 'Jamais visibles par le client.',
    },
    archive: 'Archiver le client',
    restore: 'Restaurer le client',
    archivedToast: 'Client archivé.',
    restoredToast: 'Client restauré.',
    confirmArchive: {
      title: 'Archiver {{name}} ?',
      description: 'Le client disparaîtra des listes et des recherches. Ses ménages, soumissions et paiements sont conservés. Vous pourrez le restaurer.',
    },
    actions: { newJob: 'Créer un ménage', newQuote: 'Créer une soumission', message: 'Message' },
    tabs: {
      properties: 'Propriétés',
      jobs: 'Ménages',
      agreements: 'Services récurrents',
      quotes: 'Soumissions',
      payments: 'Paiements',
      conversations: 'Conversations',
    },
    upcoming: 'Ménages à venir',
    history: 'Historique',
    noUpcoming: 'Aucun ménage prévu.',
    noHistory: 'Aucun ménage passé.',
    noProperty: 'Ce client n’a encore aucune propriété.',
    noQuote: 'Aucune soumission pour ce client.',
    quoteCreated: 'créée le {{date}}',
    noPayment: 'Aucun paiement.',
    payment: 'Paiement',
    paidOn: 'payé le {{date}}',
    refunded: 'remboursé {{amount}}',
    noConversation: 'Aucune conversation avec ce client.',
  },
  agreements: {
    empty: 'Aucun service récurrent.',
    emptyHint: 'Un service récurrent est créé quand le client accepte une soumission hebdomadaire, aux deux semaines ou mensuelle.',
    actions: 'Actions sur le service',
    pricePerVisit: 'Prix par visite',
    period: 'Période',
    noEnd: 'sans fin',
    pausedFrom: 'En pause depuis le {{from}}',
    pausedRange: 'En pause du {{from}} au {{to}}',
    action: {
      PAUSE: 'Mettre en pause',
      RESUME: 'Reprendre le service',
      CANCEL: 'Annuler le service',
      CHANGE_SCHEDULE: 'Changer l’horaire',
      CHANGE_PRICE: 'Changer le prix',
    },
    hint: {
      PAUSE: 'Les ménages prévus pendant la pause sont annulés. Sans date de fin, la pause dure jusqu’à la reprise.',
      RESUME: '',
      CANCEL: '',
      CHANGE_SCHEDULE: 'Les visites de l’ancien rythme à partir de cette date sont annulées (sauf celles modifiées à la main) et les nouvelles sont générées.',
      CHANGE_PRICE: 'Le nouveau prix s’applique aux prochaines visites générées.',
    },
    confirm: {
      RESUME: { title: 'Reprendre le service ?', description: 'Les prochaines visites seront générées à partir d’aujourd’hui.' },
      CANCEL: { title: 'Annuler ce service récurrent ?', description: 'Toutes les visites futures non commencées seront annulées. Aucune pénalité n’est appliquée.' },
      PAUSE: { title: '', description: '' },
      CHANGE_SCHEDULE: { title: '', description: '' },
      CHANGE_PRICE: { title: '', description: '' },
    },
    pauseFrom: 'Pause à partir du',
    pauseUntil: 'Jusqu’au',
    pauseUntilHint: 'Facultatif.',
    startDate: 'À partir du',
    newPrice: 'Nouveau prix par visite ($)',
    currentPrice: 'Prix actuel : {{amount}}',
    applyFuture: 'Appliquer aussi aux ménages déjà prévus',
    reason: 'Raison',
    done: {
      PAUSE: 'Service mis en pause.',
      RESUME: 'Service repris.',
      CANCEL: 'Service annulé.',
      CHANGE_SCHEDULE: 'Horaire modifié.',
      CHANGE_PRICE: 'Prix modifié.',
    },
    result: {
      cancelled_one: '{{count}} ménage annulé',
      cancelled_other: '{{count}} ménages annulés',
      generated_one: '{{count}} ménage créé',
      generated_other: '{{count}} ménages créés',
      updated_one: '{{count}} ménage mis à jour',
      updated_other: '{{count}} ménages mis à jour',
    },
  },
  jobs: {
    new: {
      title: 'Créer un ménage',
      description: 'Ménage ponctuel pour {{name}}, sans soumission.',
      noProperty: 'Ajoutez d’abord une propriété à ce client.',
      price: 'Prix client ($)',
      priority: 'Priorité',
      specialInstructions: 'Instructions pour l’équipe',
      specialInstructionsHint: 'Visibles par les employés assignés.',
      notes: 'Notes internes',
      notesHint: 'Visibles seulement par le bureau.',
      submit: 'Créer le ménage',
      created: 'Ménage créé. Il reste à l’assigner.',
    },
  },

  // ---------------------------------------------------------------- properties
  properties: {
    title: 'Propriétés',
    description: 'Toutes les adresses actives des clients.',
    count_one: '{{count}} propriété active',
    count_other: '{{count}} propriétés actives',
    search: 'Nom, adresse ou ville',
    empty: 'Aucune propriété active.',
    emptySearch: 'Aucune propriété ne correspond à cette recherche.',
    emptyHint: 'Les propriétés s’ajoutent depuis la fiche d’un client.',
    noSector: 'Sans secteur',
    openClient: 'Voir le client',
  },
  property: {
    add: 'Ajouter une propriété',
    addHint: 'Nouvelle adresse pour {{name}}. Le secteur est détecté automatiquement à partir de l’adresse.',
    created: 'Propriété ajoutée.',
    edit: 'Modifier la propriété',
    saved: 'Propriété mise à jour.',
    inactive: 'Inactive',
    unitShort: 'app. {{unit}}',
    seeClient: 'Voir le client',
    permanentInfo: 'Informations permanentes',
    upcomingJobs: 'Ménages à venir à cette adresse',
    noUpcoming: 'Aucun ménage prévu à cette adresse.',
    sections: { address: 'Adresse', characteristics: 'Caractéristiques', onSite: 'Sur place' },
    fields: {
      name: 'Nom de la propriété',
      nameHint: 'Ex. : Maison, Chalet, Condo du centre-ville.',
      propertyType: 'Type',
      addressLine1: 'Adresse',
      unit: 'Appartement / unité',
      city: 'Ville',
      province: 'Province',
      postalCode: 'Code postal',
      sectorHint: 'Laissez « Détection automatique » pour utiliser la position de l’adresse.',
      sectorAuto: 'Détection automatique',
      floors: 'Étages',
      bedrooms: 'Chambres',
      bathrooms: 'Salles de bain',
      kitchens: 'Cuisines',
      familyRooms: 'Espaces familiaux',
      squareFeet: 'Superficie (pi²)',
      hasPets: 'Animaux sur place',
      petDetails: 'Détails sur les animaux',
      parkingInfo: 'Stationnement',
      permanentNotes: 'Notes permanentes (visibles par l’équipe assignée)',
      preferences: 'Préférences du client',
      specialProducts: 'Produits particuliers',
      forbiddenAreas: 'Zones interdites',
    },
  },
  notes: {
    title: 'Notes',
    description: 'Chaque note a une visibilité : interne (bureau), employés assignés ou client.',
    placeholder: 'Ajouter une note…',
    visibility: 'Visibilité',
    vis: { INTERNAL: 'Interne', EMPLOYEE: 'Employés', CLIENT: 'Client' },
    visHint: {
      INTERNAL: 'Visible seulement par le bureau.',
      EMPLOYEE: 'Visible par le bureau et les employés assignés à cette adresse.',
      CLIENT: 'Visible par le bureau, les employés et le client.',
    },
    add: 'Ajouter',
    added: 'Note ajoutée.',
    deleted: 'Note supprimée.',
    empty: 'Aucune note.',
    confirmDelete: 'Supprimer cette note ?',
  },
  access: {
    title: 'Accès à la propriété',
    audited: 'Informations sensibles (codes, clés, alarme). Chaque consultation est enregistrée dans le journal d’audit avec votre nom.',
    show: 'Afficher les accès',
    hide: 'Masquer',
    empty: 'Aucune instruction d’accès.',
    add: 'Ajouter un accès',
    kind: 'Type',
    label: 'Description',
    labelPlaceholder: 'Ex. : Porte avant, Boîte à clé du garage',
    secret: 'Code / valeur',
    notes: 'Précisions',
    saved: 'Accès enregistré.',
    deleted: 'Accès supprimé.',
    confirmDelete: 'Supprimer cette instruction d’accès ?',
  },
  checklist: {
    title: 'Ajustements de la liste de tâches',
    description: 'Tâches ajoutées ou retirées pour cette propriété, appliquées à chaque nouveau ménage.',
    empty: 'Aucun ajustement : la liste standard du service s’applique.',
    addedIn: 'Ajoutée · {{section}}',
    removedFromTemplate: 'Retirée de la liste standard',
    unknownItem: 'Tâche de la liste standard',
    added: 'Tâche ajoutée.',
    removed: 'Tâche retirée',
    deleted: 'Ajustement supprimé.',
    section: 'Section',
    taskLabel: 'Tâche',
    placeholder: 'Ex. : Détartrer la douche principale',
    add: 'Ajouter la tâche',
    remove: 'Supprimer l’ajustement',
    confirmDelete: 'Supprimer cet ajustement ?',
    confirmDeleteHint: 'Les prochains ménages utiliseront la liste standard pour cette tâche. Les ménages déjà créés ne changent pas.',
  },

  // ---------------------------------------------------------------- staff messages
  messages: {
    title: 'Messages',
    description: 'Conversations avec les clients et les employés.',
    select: 'Choisissez une conversation.',
    empty: 'Aucune conversation pour le moment.',
    emptyFiltered: 'Aucune conversation avec ces filtres.',
    filters: {
      label: 'Filtrer les conversations',
      all: 'Tous',
      mine: 'À moi',
      unassigned: 'Non assignées',
      open: 'Ouvertes',
      waiting: 'En attente',
      resolved: 'Résolues',
      kind: 'Type de conversation',
      allKinds: 'Clients et employés',
      clients: 'Clients',
      employees: 'Employés',
    },
    kind: { client: 'Client', employee: 'Employé', internal: 'Interne' },
    panel: {
      related: 'Liens',
      job: 'Ménage lié',
      quote: 'Soumission liée',
      property: 'Propriété liée',
      priority: 'Priorité',
      assignee: 'Responsable',
      assignMe: 'M’assigner la conversation',
      you: 'Vous',
      assigned: 'Assignée',
      noAccount: 'Ce client n’a pas de compte en ligne : il ne verra pas les messages.',
      mentionHint: 'Dans une note interne, écrivez @Prénom pour aviser un collègue.',
    },
    new: {
      title: 'Nouveau message',
      description: 'Ouvrir une conversation avec un client ou un employé.',
      recipientKind: 'Destinataire',
      chooseEmployee: 'Choisir un employé',
      to: 'À :',
    },
  },
};
